import AxiosModel from "./AxiosModel";
import {getValues} from "../helpers/functions";

const tokenEndpoints = new Set([
    '/user/oidcToken',
    '/user/refresh',
    '/user/external/oidcToken'
]);

onmessage = async function(e) {
    const [action, ...args] = e.data;

    switch (action) {
        case 'initialize': {
            this.axiosInstance = new AxiosModel(...args);
            this.requests = {};
            break;
        }
        case 'request': {
            const [id, method, ...others] = args;

            const url = others[0];
            const isRefreshRequest = url === '/user/refresh';

            if (isRefreshRequest) {
                // Create promise for other requests to await on
                this.refreshPromise = new Promise(res => this.refreshPromiseResolve = res)
                    .finally(() => this.refreshPromise = null);
                // Wait for all activePromises before proceeding
                const activePromises = getValues(this.requests).map(request => request.promise);
                await Promise.all(activePromises);

                // Else, wait for refresh if active
            } else if (this.refreshPromise != null) {
                await this.refreshPromise;
            }

            const controller = new AbortController();
            const promise = this.axiosInstance[method](...others, {signal: controller.signal})
                .then(res => {
                    const sanitizedResponse = sanitizeResponse(res);
                    // Update axiosToken
                    if (tokenEndpoints.has(res.config.url)) {
                        this.axiosInstance.setAxiosToken(sanitizedResponse.data.token);
                        delete sanitizedResponse.data.token;
                    }
                    postMessage(['resolve', id, sanitizedResponse]);
                })
                .catch(error => postMessage(['reject', id, sanitizeResponseError(error)]))
                .finally(() => {
                    // Resolve refreshPromise
                    if (isRefreshRequest) {
                        this.refreshPromiseResolve();
                    }
                    delete this.requests[id]
                });

            this.requests[id] = {controller, promise};
            break;
        }
        case 'cancel': {
            const [id] = args;
            const request = this.requests[id];
            if (request != null) {
                request.controller.abort();
            }
            break;
        }
        default:
            this.axiosInstance[action](...args);
    }
}

function sanitizeResponse(res) {
    return {
        status: res.status,
        statusText: res.statusText,
        headers: res.headers,
        data: res.data
    };
}

function sanitizeResponseError(error) {
    if (error != null && typeof error === 'object') {
        const {config, response, request, ...sanitizedError} = error;
        // Clean functions
        for (const key of Object.keys(sanitizedError)) {
            if (typeof sanitizedError[key] === 'function') {
                delete sanitizedError[key];
            }
        }

        if (response != null) {
            sanitizedError.response = sanitizeResponse(error.response)
        }
        if (request != null) {
            sanitizedError.request = {
                status: error.request.status,
                statusText: error.request.statusText
            };
        }
        return sanitizedError;
    }
    return error;
}